(function (angular) {
    'use strict';

    angular.module('chat2')
        /**participantProfileId
         *
         */
        .controller('chatConversationCtrl', ['$q', '$scope', '$state', '$timeout', '$stateParams', '$uibModal', 'jwtService', 'comapiChatService', 'chatAdminService', 'conversationInfo', 'teamAvatar', 'growlService', 'participantProfile', 'formTemplates', 'formService', 'participantProfileId', 'typingService', 'teamSettingsService', 'sharedDataService', 'profileHelper', "teamConfig", "permissionService", "rcsServices", "portalConfig",
            function ($q, $scope, $state, $timeout, $stateParams, $uibModal, jwtService, comapiChatService, chatAdminService, conversationInfo, teamAvatar, growlService, participantProfile, formTemplates, formService, participantProfileId, typingService, teamSettingsService, sharedDataService, profileHelper, teamConfig, permissionService, rcsServices, portalConfig) {

                $scope.permissionConfig = permissionService.checkPermission('tmpl:r');
                $scope.typingService = typingService;

                typingService.start(participantProfileId);

                $scope.id = $stateParams.id;

                $scope.isClosed = conversationInfo.conversation.status === "closed";

                $scope.profileId = "PLATFORMUSER\\" + jwtService.payload.sub;

                $scope.participantProfileId = participantProfileId;

                $scope.messages = conversationInfo.messages;

                $scope.conversationChannel = conversationInfo.conversation.channelId;

                if ($scope.conversationChannel === 'rcs') {
                    if (teamConfig.channels.rcs && teamConfig.channels.rcs.agentId) {
                        rcsServices.getRcsAgent($stateParams.pickedApiSpaceId, teamConfig.channels.rcs.agentId).then((agent) => {
                            //for rcs channel we're checking if profile is still agent's tester when agent's status is 'ready'
                            $scope.canChat = agent.status === 'ready' && participantProfile && participantProfile.profile.rcs.properties.isTester.value === true && participantProfile.profile.rcs.properties.agents.value[teamConfig.channels.rcs.agentId] && participantProfile.profile.rcs.properties.agents.value[teamConfig.channels.rcs.agentId] === 'active';
                        })
                    }
                    else {
                        $scope.canChat = false;
                    }

                }
                else {
                    $scope.canChat = true;
                }

                $scope.conversationInfo = conversationInfo;

                $scope.disableSend = conversationInfo.conversation.status === "closed" || participantProfile === undefined;
                $scope.sending = false;

                $scope.attachments = [];

                $scope.attachment = {};

                $scope.loading = false;
                $scope.limit = false;

                $scope.teamAvatar = teamAvatar;

                $scope.newMessage = {
                    text: undefined
                };

                $scope.hsmReEngagementConfigured = teamConfig && teamConfig.channels && teamConfig.channels.whatsApp && teamConfig.channels.whatsApp.reengagementHsm;

                var contentTypeLimits = angular.copy(sharedDataService.getChannelContentTypeLimits($scope.conversationChannel));
                var contentSizeLimitBytes = sharedDataService.getContentSizeLimitBytes($scope.conversationChannel);
                $scope.messageLengthLimit = sharedDataService.getMessageLengthLimit($scope.conversationChannel);
                var borderContentTypeLimits = angular.copy(contentTypeLimits);

                $scope.canAdd = (type, isAttachment) => {
                    var mappings = sharedDataService.getSupportedSuperTypes($scope.conversationChannel)[type];
                    if (mappings) {
                        var result = false;
                        for (var mapping of mappings) {
                            result = result ? result : canAddType(mapping, isAttachment);
                        }
                        return result;
                    } else {
                        return canAddType(type, isAttachment);
                    }
                }

                function canAddType(type, isAttachment) {
                    if (type) {
                        var limit = isAttachment && $scope.newMessage.text && type === "text" ? 1 : 0
                        if ($scope.newMessage.text || type === "text") {
                            if (contentTypeLimits.text && (contentTypeLimits.text[type] === limit || Object.values(contentTypeLimits.text).some((t) => t < 0))) {
                                return false;
                            }
                        }
                        for (var attachment of $scope.attachments) {
                            if (contentTypeLimits[attachment.type] && (contentTypeLimits[attachment.type][type] === limit || Object.values(contentTypeLimits[attachment.type]).some((t) => t < 0))) {
                                return false
                            }
                        }
                    }
                    return true;
                };

                function changeContentTypeLimitsValues(type, by) {
                    for (var messageType in contentTypeLimits) {
                        var singleMapping = contentTypeLimits[messageType];
                        if (singleMapping[type] || singleMapping[type] === 0) {
                            var val = singleMapping[type] + by;
                            if (val <= borderContentTypeLimits[messageType][type]) {
                                singleMapping[type] = val;
                            }
                        }
                    }
                }

                $scope.conversationOutOfWindow = function () {
                    //checking if we are already out of conversation window
                    if ($scope.conversationChannel === "whatsApp" && participantProfile && participantProfile.profile && participantProfile.profile.whatsApp && participantProfile.profile.whatsApp.properties.timeLeftToChat) {
                        return profileHelper.outOfCounter(participantProfile.profile.whatsApp.properties.timeLeftToChat);
                    }
                    if ($scope.conversationChannel === "fbMessenger") {
                        if (portalConfig.disableFacebookChatWindow === "true" && participantProfile && participantProfile.profile && participantProfile.profile.facebook && !participantProfile.profile.facebook.properties.timeLeftToChat.value) {
                            return false;
                        }
                        if (participantProfile && participantProfile.profile && participantProfile.profile.facebook && participantProfile.profile.facebook.properties.timeLeftToChat) {
                            return profileHelper.outOfCounter(participantProfile.profile.facebook.properties.timeLeftToChat);
                        }
                    }
                    return false;
                };

                $scope.typeSupported = function (type) {
                    var mappings = sharedDataService.getTypesMapping()[type];
                    if (mappings) {
                        return sharedDataService.checkIfAnyTypeSupported(mappings, $scope.conversationChannel);
                    } else {
                        return sharedDataService.checkIfTypeSupported(type, $scope.conversationChannel);
                    }
                }

                $scope.getSupportedTypes = function (type) {
                    var mappings = sharedDataService.getTypesMapping()[type];
                    return sharedDataService.getSupportedTypes(mappings, $scope.conversationChannel);
                }

                $scope.formTemplates = (formTemplates || []).filter(function (singleForm) {
                    return singleForm.tags && singleForm.tags.includes('chat');
                });

                $scope.hideAttachments = function () {
                    $scope.visibleAttachments = false;
                };

                $scope.popoverAttachments = {
                    templateUrl: '/components/toolkit/chat/templates/attachmentsPopover.html',
                    isOpen: false
                };

                $scope.isOpen = false;
                $scope.hidePopover = function () {
                    $scope.isOpen = false;
                };

                $scope.sendForm = function (formTemplateId) {
                    formService.sendForm($stateParams.pickedApiSpaceId, $stateParams.id, formTemplateId).then(function (result) {
                        $scope.hideAttachments();
                    }).catch(function (error) {
                        growlService.danger("Form didn't send due to: " + error);
                    });
                };

                $scope.$on('MemoryConversationStore.createMessage', function (event, message) {
                    if (message.conversationId === $scope.id &&
                        message.senderId.indexOf('PLATFORMUSER') === -1) {
                        // Mark new message as read
                        comapiChatService.markMessageAsRead(message);
                    }
                });

                $scope.$on("$destroy", function () {
                    typingService.stop();
                });

                // Mark all messages as read
                comapiChatService.markAllMessagesAsRead($scope.id);

                // If this conversation gets removed from the store, need to redirect back   
                $scope.$on('MemoryConversationStore.deleteConversation', function (event, conversationId) {
                    if (conversationId === $scope.id) {

                        var params = {
                            pickedApiSpaceId: $stateParams.pickedApiSpaceId,
                            scope: $stateParams.scope,
                            filter: $stateParams.conversationStatus
                        };

                        $state.go("main.apiSpace.chat2.chat", params, { reload: true });
                    }
                });

                $scope.removeAttachment = function (attachment) {
                    var index = $scope.attachments.indexOf(attachment);

                    if (index !== -1) {
                        $scope.attachments.splice(index, 1);
                        changeContentTypeLimitsValues(attachment.type, 1);
                    }
                }

                $scope.getAttachmentHtml = function (attachment) {
                    return "<span>Name: " + attachment.file.name + "</span>"
                }

                $scope.openList = false;
                $scope.openAttachmentList = function () {
                    $scope.openList = !$scope.openList;
                }

                var shortcutHandler = function (e) {
                    //works only when other modals are closed
                    if (document.getElementsByClassName("modal").length === 0) {
                        if ((e.ctrlKey && e.charCode == 17)) {
                            e.preventDefault();
                            e.stopPropagation();
                            $scope.openTemplatesModal();
                        }
                    }
                    else {
                        // do nothing
                    }
                }
                if ($scope.permissionConfig) {
                    document.addEventListener("keypress", shortcutHandler);
                }

                $scope.$on('$destroy', function () {
                    document.removeEventListener("keypress", shortcutHandler);
                });

                $scope.openTemplatesModal = function () {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'components/messageTemplates/templates/chatTemplatesModal.html',
                        controller: 'chatTemplatesModal',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            templatesData: ['$q', '$stateParams', 'templateService', function ($q, $stateParams, templateService) {
                                return templateService.getTemplates($stateParams.pickedApiSpaceId)
                                    .then(function (result) {
                                        return result;
                                    }).catch(function (result) {
                                        var deferred = $q.defer();
                                        if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                        return deferred.promise;
                                    });
                            }],
                            conversationChannel: function () {
                                return $scope.conversationChannel;
                            }
                        }
                    });

                    modalInstance.result.then(function (result) {
                        $scope.template = result;
                        var messageFromTemplate = {};
                        messageFromTemplate.parts = $scope.template.messageParts;

                        $scope.sendTemplate(messageFromTemplate);

                    }, function () {
                        // $log.info('Modal dismissed at: ' + new Date());
                    });
                };

                $scope.onLoad = function (data) {
                    if (!data.type || !data.subtype) {
                        growlService.danger("Unrecognised file type");
                    }
                    else if (contentSizeLimitBytes != -1 && data.file && (data.file.size > contentSizeLimitBytes)) {
                        growlService.danger("This file size is not supported");
                    }
                    else if ($scope.typeSupported(data.type + "/" + data.subtype)) {
                        if ($scope.canAdd(data.type, true)) {
                            $scope.$apply(function () {
                                $scope.attachments.push(data);
                                changeContentTypeLimitsValues(data.type, -1);

                                $scope.hidePopover();
                            });

                        } else {
                            growlService.danger("This channel cannot handle more messages of this type");
                        }
                    } else {
                        growlService.danger("File type isn't supported");
                    }
                }

                $scope.sendTemplate = function (message) {
                    return comapiChatService.chatClient.messaging.sendMessage($stateParams.id, message)
                        .then(function (result) {
                            $scope.sending = false;
                            return result;
                        })
                        .catch(function (error) {
                            $scope.sending = false;
                            growlService.danger("Failed to send message");
                            throw error;
                        });
                };
                $scope.sendMessage = function () {
                    //we trim message because in textarea component default trim is removed
                    if ((!$scope.newMessage.text || !$scope.newMessage.text.trim()) && !$scope.attachments.length) {
                        return;
                    }
                    $scope.newMessage.text = $scope.newMessage.text ? $scope.newMessage.text.trim() : "";
                    if ($scope.sending) {
                        return $q.resolve(true);
                    }

                    if ($scope.attachments.length > 0) {
                        $scope.sending = true;
                        var contentDataArray = [];
                        angular.forEach($scope.attachments, function (attachment) {
                            contentDataArray.push(COMAPI_CHAT.ContentData.createFromFile(attachment.file))
                        })

                        return comapiChatService.chatClient.messaging.messageFromContentDataArray(contentDataArray, $scope.newMessage.text)
                            .then(function (message) {
                                return comapiChatService.chatClient.messaging.sendMessage($stateParams.id, message)
                            })
                            .then(function (result) {
                                $scope.newMessage.text = "";
                                $scope.attachments = [];
                                $scope.hideAttachments();
                                $scope.sending = false;

                                contentTypeLimits = angular.copy(borderContentTypeLimits);

                                return result;
                            })
                            .catch(function (error) {
                                $scope.sending = false;
                                growlService.danger("Failed to send message");
                                throw error;
                            });

                    } else if ($scope.newMessage.text !== undefined && $scope.newMessage.text.length > 0) {
                        $scope.sending = true;
                        return comapiChatService.chatClient.messaging.sendTextMessage($stateParams.id, $scope.newMessage.text)
                            .then(function () {
                                $scope.newMessage.text = "";
                                $scope.sending = false;
                                return $q.resolve(true);
                            }).catch(function (error) {
                                $scope.sending = false;
                                console.error("Failed to send message", error);
                                growlService.danger("Failed to send message");
                            });

                    } else {
                        return $q.resolve(false);
                    }
                }

                /**
                 * 
                 */
                $scope.getMoreHistory = function () {

                    var deferred = $q.defer();

                    if ($scope.loading) {
                        deferred.resolve(false);
                    } else {

                        if ($scope.limit === false) {

                            $scope.loading = true;
                            comapiChatService.getPreviousMessages($scope.id)
                                .then(function (result) {
                                    $scope.loading = false;
                                    if (result === false) {
                                        $scope.limit = true;
                                    }
                                    deferred.resolve(result);
                                })
                                .catch(function (error) {
                                    $scope.loading = false;
                                    deferred.resolve(false);
                                });
                        } else {
                            deferred.resolve(false);
                        }
                    }

                    return deferred.promise;
                }

                /**
                 * 
                 */
                $scope.onKeyDown = function (event, isOpen) {

                    if (event.shiftKey || isOpen) {
                        // do nothing
                    } else if (event.keyCode === 13) {
                        event.preventDefault();
                        if ($scope.newMessage.text) {
                            // this is the text prior to the newline getting added
                            var text = $scope.newMessage.text;
                            $scope.sendMessage();
                            typingService.sendIsTypingOff();
                        }
                    } else {
                        typingService.sendIsTypingOn();
                    }
                }

                $scope.transfer = function () {
                    var modalInstance = $uibModal.open({
                        animation: true,
                        templateUrl: 'components/toolkit/chat/templates/transferChatModal.html',
                        controller: 'transferChatModal',
                        size: 'transfer-conversation',
                    });

                    return modalInstance.result
                        .then(function (data) {

                            var details = {
                                agentId: data.profileId,
                                teamId: data.teamId
                            };

                            return chatAdminService.assign($stateParams.pickedApiSpaceId, $stateParams.id, details);
                        })
                        .then(function (result) {

                            var params = {
                                pickedApiSpaceId: $stateParams.pickedApiSpaceId,
                                scope: $stateParams.scope,
                                filter: $stateParams.conversationStatus
                            };

                            $state.go("main.apiSpace.chat2.chat", params, { reload: true });

                            growlService.success("Chat successfully transferred");
                            return Promise.resolve(true);
                        })
                        .catch(function (error) {
                            if (error !== "cancel") {
                                growlService.danger("Failed to transfer chat");
                                throw error;
                            }
                        });
                };

                $scope.closeConversation = function () {

                    // hide the send close message if no message
                    return teamSettingsService.getChatConfig($stateParams.pickedApiSpaceId)
                        .then(function (result) {

                            var team = result.teams.find(function (t) {
                                return t.teamId === conversationInfo.conversation.teamId;
                            });

                            var modalInstance = $uibModal.open({
                                animation: true,
                                templateUrl: 'components/toolkit/chat/templates/closeConversationModal.html',
                                controller: 'closeConversationModal',
                                size: 'sm',
                                resolve: {
                                    showSendCloseMessageSwitch: team ? !!team.settings.closeMessage : false
                                }
                            });

                            return modalInstance.result
                                .then(function (closeOptions) {

                                    return chatAdminService.close($stateParams.pickedApiSpaceId, conversationInfo.conversation.id, {
                                        bypassMessage: !closeOptions.sendCloseMessage
                                    });
                                })
                                .then(function (result) {
                                    return $q.resolve(true);
                                });

                        });

                }

            }])
        .controller('closeConversationModal', ["$scope", "$uibModalInstance", "showSendCloseMessageSwitch",
            function ($scope, $uibModalInstance, showSendCloseMessageSwitch) {

                $scope.showSendCloseMessageSwitch = showSendCloseMessageSwitch;

                $scope.closeOptions = {
                    sendCloseMessage: showSendCloseMessageSwitch
                }

                $scope.close = function () {
                    $uibModalInstance.close($scope.closeOptions);
                };

                $scope.cancel = function () {
                    $uibModalInstance.dismiss();
                };

            }]);


})(window.angular);
